/**
 * @ComponentFor Avensia.Shop.Features.Cms.Pages.Article.ArticlePageViewModel
 */
import React from "react";
import connect from "Shared/connect";
import { epiPropertyValue, EpiProperty } from "@avensia/nitro5-scope-episerver";
import Main from "Shared/PageLayout";
import { LARGE } from "Shared/breakpoints";
import * as styles from "./base.scss";
class ArticlePage extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.hero },
                !!epiPropertyValue(this.props.page.hero) && (React.createElement("div", { className: styles.aspectRatio },
                    React.createElement("img", { src: epiPropertyValue(this.props.page.hero).url, alt: epiPropertyValue(this.props.page.name) }))),
                React.createElement(Main, null,
                    React.createElement("div", { className: styles.header },
                        React.createElement(EpiProperty, { component: "h1", for: this.props.page.name, className: styles.inspiration })))),
            React.createElement("div", { className: styles.content },
                React.createElement(Main, null,
                    React.createElement("div", { className: styles.mainWrapper },
                        React.createElement("div", { className: styles.leftColumn },
                            this.props.currentBreakpoint < LARGE && (React.createElement("div", { className: styles.preambleColumn },
                                React.createElement(EpiProperty, { for: this.props.page.preamble, className: styles.preamble }))),
                            React.createElement("div", { className: styles.byLineColumn },
                                React.createElement(EpiProperty, { for: this.props.page.articleType, className: styles.preamble }),
                                React.createElement("div", { className: styles.byLine },
                                    React.createElement(EpiProperty, { for: this.props.page.byLine, className: styles.paragraph }),
                                    React.createElement("div", { className: styles.paragraph }, this.props.date)))),
                        React.createElement("div", { className: styles.centerColumn },
                            this.props.currentBreakpoint >= LARGE && (React.createElement("div", { className: styles.preambleDesktop },
                                React.createElement(EpiProperty, { for: this.props.page.preamble, className: styles.preamble }))),
                            React.createElement(EpiProperty, { component: "h2", for: this.props.page.mainBodyHeader, className: styles.inspiration }),
                            React.createElement(EpiProperty, { for: this.props.page.mainBody, className: styles.paragraph }),
                            React.createElement("div", { className: styles.mainContent },
                                React.createElement(EpiProperty, { for: this.props.page.mainContent }))),
                        React.createElement("div", { className: styles.rightColumn },
                            React.createElement("div", null,
                                React.createElement(EpiProperty, { for: this.props.page.sideBarBody })),
                            React.createElement("div", null,
                                React.createElement(EpiProperty, { for: this.props.page.sideBarContent }))))))));
    }
}
export default connect((state) => ({
    currentBreakpoint: state.currentBreakpoint,
}))(ArticlePage);
